import { useEffect, useState } from "react"
import { motion, AnimatePresence, useScroll, useSpring } from "framer-motion"
import Logo from "./Logo"

const links = [
  { id: "servicos", label: "Serviços" },
  { id: "processo", label: "Como trabalhamos" },
  { id: "projetos", label: "Projetos" },
  { id: "depoimentos", label: "Depoimentos" },
]

export const scrollToId = (id) => {
  if (id === "top") {
    window.scrollTo({ top: 0, behavior: "smooth" })
    return
  }
  const el = document.getElementById(id)
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" })
}

const Nav = () => {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)
  const { scrollYProgress } = useScroll()
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 30 })

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : ""
    const onKey = (e) => e.key === "Escape" && setOpen(false)
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [open])

  const go = (id) => (e) => {
    e.preventDefault()
    setOpen(false)
    scrollToId(id)
  }

  return (
    <>
      <motion.div className="k-progress" style={{ scaleX: progress }} />
      <header className={`k-nav ${scrolled ? "is-scrolled" : ""}`}>
        <div className="k-nav__inner">
          <a href="#top" className="k-nav__brand" onClick={go("top")} aria-label="Ir para o início">
            <Logo className="k-nav__logo" />
          </a>

          <nav className="k-nav__links" aria-label="Principal">
            {links.map((l) => (
              <a key={l.id} href={`#${l.id}`} onClick={go(l.id)}>
                {l.label}
              </a>
            ))}
          </nav>

          <a href="#contato" className="k-btn k-btn--ink k-nav__cta" onClick={go("contato")}>
            Solicitar orçamento
            <span className="k-btn__arrow" aria-hidden>→</span>
          </a>

          <button
            className={`k-burger ${open ? "is-open" : ""}`}
            onClick={() => setOpen(!open)}
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            aria-expanded={open}
          >
            <span />
            <span />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            className="k-menu"
            initial={{ clipPath: "circle(0% at calc(100% - 40px) 36px)" }}
            animate={{ clipPath: "circle(150% at calc(100% - 40px) 36px)" }}
            exit={{ clipPath: "circle(0% at calc(100% - 40px) 36px)" }}
            transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
          >
            <ul>
              {[...links, { id: "contato", label: "Contato" }].map((l, i) => (
                <motion.li
                  key={l.id}
                  initial={{ opacity: 0, y: 40 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 + i * 0.06 }}
                >
                  <a href={`#${l.id}`} onClick={go(l.id)}>
                    <span className="k-menu__num">0{i + 1}</span>
                    {l.label}
                  </a>
                </motion.li>
              ))}
            </ul>
            <p className="k-menu__foot">kjrdesenvolvimento@gmail.com</p>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Nav
